/**
 * 用户主体类型枚举
 */
export const EnterpriseType = {
  // 普通企业
  NORMAL_ENTERPRISE: {
    value: '0',
    label: '普通企业'
  },
  // 机构
  ORGANIZATION: {
    value: '1',
    label: '机构'
  },
  // 渠道
  CHANNEL: {
    value: '2',
    label: '渠道'
  }

}


